const getters = {
  module: state => state.module,
  topic: state => state.topic,
  userInfo: state => state.userInfo,
  isLoading: state => state.isLoading,
  answerTime: state => state.answerTime,
  qTime: state => state.answerTime,
  questionId: state => state.questionId,
  stopTimer: state => state.stopTimer,
  moduleInfo: state => state.moduleInfo,
  source: state => state.source,
  knowledgeInfo: state => state.knowledgeInfo,
  learnInfo: state => state.learnInfo,
  activity: state => state.activity,
  component: state => state.component,
  choosedOptions: state => state.choosedOptions,
  gameData: state => state.gameData,
  autoRobot: state => state.autoRobot,
  crtstalNum: state => state.crtstalNum,
  studyBeatArea: state => state.studyBeatArea,
  userSubmitIsNeedAlert: state => state.userSubmitIsNeedAlert,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js